export type { InjectedProps } from './with-path-params';
export { default as withPathParams, PathParamsProvider } from './with-path-params';
